import React, { Ref } from 'react'
import {
    StyledFormHeader,
    PageLabel,
    PageTitle,
    Container,
} from '@snsw-gel/page'
import { forwarded, useId } from '@snsw-gel/utils'
import {
    ProgressStepper,
    ProgressStepperProps,
} from '@snsw-gel/progress-stepper'

export interface FormHeaderProps {
    id?: string
    className?: string
    label?: string
    title: string
    stepsList?: ProgressStepperProps['stepsList']
}

export const FormHeader = forwarded(
    (props: FormHeaderProps, ref?: Ref<HTMLDivElement>) => {
        const { id, className, label, title, stepsList, ...rest } = props

        const elemId = useId(id)

        return (
            <StyledFormHeader
                id={elemId}
                className={className}
                {...rest}
                ref={ref}
            >
                <Container>
                    {label && <PageLabel>{label}</PageLabel>}
                    <PageTitle>{title}</PageTitle>
                    {stepsList && (
                        <ProgressStepper
                            className='form-header__progress'
                            stepsList={stepsList}
                        />
                    )}
                </Container>
            </StyledFormHeader>
        )
    },
)

// @ts-ignore
FormHeader.displayName = 'FormHeader'
